var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('AppHeader',{staticClass:"hide-sm d-block--md",attrs:{"variant":'light'}}),_c('main',{staticClass:"app-content app-content--default"},[_c('router-view')],1),_c('AppFooter',{attrs:{"variant":'default'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }